var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14744 8.6866C6.06601 8.77113 5.93399 8.77113 5.85256 8.6866L1.56107 4.23172C1.47964 4.14719 1.47964 4.01014 1.56107 3.92561L2.15083 3.3134C2.23226 3.22887 2.36428 3.22887 2.44571 3.3134L5.85256 6.84995C5.93399 6.93448 6.06601 6.93448 6.14744 6.84995L9.55429 3.3134C9.63572 3.22887 9.76774 3.22887 9.84917 3.3134L10.4389 3.92561C10.5204 4.01014 10.5204 4.14719 10.4389 4.23172L6.14744 8.6866Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewron);
export default __webpack_public_path__ + "static/media/iconChewron.352dce7ec8aeceab7efb6280b0ee476c.svg";
export { ForwardRef as ReactComponent };